module.exports = __webpack_public_path__ + "img/sm-linkedin-o.3482743a.svg";